// В.2.e-2: Вирус HV-14 (liv_virus_hv_14, epic Действие).
// «Уничтожает выбранного вражеского юнита и призывает его копию на
//  случайную свою ячейку, но наносит 5 урона своему Герою».
//
// Picker: только ВРАЖЕСКИЕ юниты на поле. Если у врага нет юнитов —
// Действие сгорает.
//
// Эффект (последовательно):
//   1. destroyUnit(target) — direct kill (игнорирует Иммунитет, Броню).
//      Срабатывают Посмертия и on_unit_died-триггеры.
//   2. summonUnitLivLife(state, target.id, ownerIdx, null) — копия
//      template'а target'а на свободный слот игрока. Если слотов нет —
//      призыв пропускается.
//   3. applyHeroDamage(state, ownerIdx, 5) — самоурон 5 ХП Герою-
//      инициатору. Через стандартный путь (триггерит Тёмного нетраннера).

import { destroyUnit } from './destroy.js';
import { summonUnitLivLife } from './summon.js';
import { applyHeroDamage } from '../../hero-damage.js';
import { registerImplementedAbility } from './warn-unimplemented.js';

export const CARD_ID = 'liv_virus_hv_14';
const LABEL = 'Вирус HV-14';
const SELF_DAMAGE = 5;

registerImplementedAbility(CARD_ID, 'oneshot');

export function actionTargets(state, playerIdx) {
  const enemy = state.players?.[1 - playerIdx];
  if (!enemy) return [];
  return enemy.unitsOnField().filter(u => u.type === 'unit');
}

export function resolve(state, playerIdx, target /*, opts */) {
  const enemy = state.players?.[1 - playerIdx];
  const me = state.players?.[playerIdx];
  if (!enemy || !me) {
    state.log?.add(`☠ ${LABEL}: некорректный state — Действие сгорает`);
    return { ok: true, skipped: true };
  }
  const enemyUnits = enemy.unitsOnField().filter(u => u.type === 'unit');
  if (enemyUnits.length === 0) {
    state.log?.add(`☠ ${LABEL}: у врага нет юнитов — Действие сгорает`);
    return { ok: true, skipped: true };
  }
  if (!target || !target.isAlive || !target.isAlive() ||
      target.type !== 'unit' || target.ownerId !== (1 - playerIdx)) {
    state.log?.add(`☠ ${LABEL}: цель недоступна — Действие сгорает`);
    return { ok: true, skipped: true };
  }
  const copyId = target.id;
  // 1) Уничтожение врага.
  destroyUnit(state, target, 1 - playerIdx, /*killer=*/ null, /*killerIdx=*/ playerIdx);
  // 2) Копия на свою сторону. Если нет слотов — пропуск.
  const r = summonUnitLivLife(state, copyId, playerIdx, null);
  if (r.success) {
    state.log?.add(
      `☠ ${LABEL} [${me.name}]: копия ${r.card.name_ru} на (линия ${r.line + 1}, слот ${r.slot + 1})`
    );
  } else {
    state.log?.add(`☠ ${LABEL} [${me.name}]: нет свободного слота — копия не призвана`);
  }
  // 3) Самоурон Герою.
  applyHeroDamage(state, playerIdx, SELF_DAMAGE, { sourceLabel: LABEL });
  return { ok: true };
}
